export default __webpack_public_path__ + "static/media/CK_Symbol.825d78d3.svg";